import _ from 'lodash';
import MainMenuActions from '../actions/MainMenuCRUDActions';
import Actions from '../actions/actions';
import { retrievedAll, update, deleteLocalFirst, setBusy, setUnBusy } from './common/commonReducers';


const initialState = {
  busy: false,
  entities: [],
};

const retrieved = (state, action) => {
  const newState = _.cloneDeep(state);
  newState.busy = false;
  let poweredByIndex = newState.entities.findIndex(m => m.sortOrder === 999);
  poweredByIndex = (poweredByIndex === -1)
    ? state.entities.length
    : poweredByIndex;
  newState.entities.splice(poweredByIndex, 0, action.entity);

  return newState;
}

export default function mainMenu(state = initialState, action) {
  switch (action.type) {
    case MainMenuActions.busyAction: return setBusy(state);
    case MainMenuActions.retrievedAction: return retrieved(state, action);
    case MainMenuActions.retrievedAllAction: return retrievedAll(state, action);
    case MainMenuActions.updateAction: return update(state, action);
    case MainMenuActions.deleteLocalAction: return deleteLocalFirst(state, action);
    case MainMenuActions.resetAction:
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY: return setUnBusy(state);
    default: return state;
  }
}
